import { useMemo } from 'react';
import { dateService } from 'services/DateService';
import { VehicleBasedDailyWeeklyDemandState } from 'types/demand.type';
import { DailyWeeklyRentalInfo } from 'types/vehicle.type';

export function usePriceWidgetDWGetOffsetDays({
  state,
  rentalInfo,
}: {
  state: VehicleBasedDailyWeeklyDemandState;
  rentalInfo: DailyWeeklyRentalInfo;
}) {
  const dayjs = dateService.getDayjs();
  const { minimumRentDuration } = rentalInfo;
  const { startDate } = state;

  const offsetDays: Date[] = useMemo(
    () =>
      [...Array(minimumRentDuration - 1)].map((_, idx) =>
        dayjs(startDate)
          .add(+idx + 1, 'day')
          .toDate()
      ),
    [minimumRentDuration, dayjs, startDate]
  );

  return { offsetDays };
}
